<template>
    <div
        class="list-brand__container"
    >
        <modal
                v-show="isModal"
                @close="closeModal"
        >
            <template v-slot:modalBody>
                <form-add-client
                        v-if="isModal"
                        :name = "brandName"
                        title="Создание бренда"
                        placeholder="Введите название нового бренда"
                        @submitForm="onSubmitBrandAdd"
                        @cancelForm="closeModal"
                />
            </template>
        </modal>
        <button
                v-if="canChange"
                class="list-brand__item list-brand__item_pointer"
                @click="onClickBrandCreate"
        >
            Создать бренд
        </button>
        <table-settings
                :labels="labels"
                :rows="Object.keys(brands).length !== 0 ? brands : []"
                :isPreloader="isPreloader()"
                :columnSettings="columnSettings"
                :isEditable="canChange"
                @editedCellInput="onChangeModel"
        >

        </table-settings>

    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceApi from "../../services/serviceApi";
import FormAddClient from "../../components/Forms/FormAddClient";
import Modal from '../../components/Base/Modal';
import schemeApi from '../../schemes/schemeApi';
import serviceAuth from "../../services/serviceAuth";
import TableSettings from "../../components/Tables/TableSettings";
import schemeSettingsBrands from '../../schemes/schemeSettingsBrands';
let {
    routeBrandEdit,
    routeBrandAdd,
    routeBrandList
} = schemeApi;
let {columnSettings, labels} = schemeSettingsBrands;
export default {
    name: 'ViewSettingsBrands',
    components: {
        TableSettings,
        FormAddClient,
        Modal
    },
    /**
     * Данные компонента
     * @property {array} brandList - список брендов
     * @property {boolean} isEmptyBrands проверка ответа на пустоту списка клиентов
     * @property {boolean} isModal флаг открытия модального окна
     * @property {string} brandName название бренда
     * @property {number} brandId id бренда
     * @property {boolean} isGettingList флаг получения списка клиентов
     * @property {boolean} isGettingUserList флаг получения списка пользователей
     * @property {boolean} isUpdatingList флаг внесения изменений в список
     * @property {boolean} canChange флаг разрешения на возможность редактировать
     */
    data: () => ({
        brandList: [],
        isEmptyBrands: false,
        isModal: false,
        brandName: '',
        brandId: null,

        isGettingList: false,
        isUpdatingList: false,
        canChange: false,

        brands: [],
        columnSettings: columnSettings,
        labels: labels,
        yOffset: null
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Бренды");
        // получаем право на редактирование
        this.canChange = serviceAuth.checkPermission(this.activeProjectId, 'change_settings');
        this.getData();
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getData() {
            this.isGettingList = true;
            try {
                let {data = {}} = await serviceApi.get(routeBrandList);
                this.brands = data.brands;
              if(this.yOffset !== null){
                setTimeout(() => {
                  console.log('скролл');
                  window.scroll(0,this.yOffset)
                }, 300)
              }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },
        isPreloader(){
            return this.isUpdatingList || this.isGettingList;
        },
        /**
         * событие клика по кнопке создать бренд
         */
        onClickBrandCreate() {
            this.isModal = true;
            this.clientId = null;
            this.clientName = '';
        },

        /**
         * событие закрытие модального окна добавления клиента
         */
        closeModal() {
            this.isModal = false;
        },
        /**
         * событие добавления имени нового бренда
         * @param {string} brandName - название нового клиента
         */
        onSubmitBrandAdd(brandName) {
            this.brandName = brandName;
            this.closeModal();
            this.postAddBrand();
        },
        /**
         * тело запроса для добавления бренда
         * @returns {object}
         */
        reqBodyPostAddBrand() {
            let reqBody = {
                editId: this.brandId,
                name: this.brandName,
                // user_id: this.activeUserId
            };
            return reqBody;
        },
        /**
         * запрос на добавление нового бренда
         * @async
         */
        async postAddBrand() {
            this.isUpdatingList = true;
            try {
                let {data = []} = await serviceApi.post(routeBrandAdd, this.reqBodyPostAddBrand());
                if(data.message){
                    alert(data.message);
                }
                if (data.error){
                    alert(data.error);
                }else{
                    this.getData();
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isUpdatingList = false;
        },
        /**
         * запрос на редактирование модели
         * @async
         * @property {array} brand - редактируемый клиент
         */
        async onChangeModel(brand){
          if (!this.canChange){
            return;
          }
          this.yOffset = window.pageYOffset;
            let postData = {
                editId: brand['id'],
                editAttribute: brand['attribute'],
                editValue: brand['value']
            };
            this.isUpdatingList = true;
            try {
                let {data = []} = await serviceApi.post(routeBrandEdit, postData);
                if(data.message){
                    // alert(data.message);
                }
                if (data.error){
                    alert(data.error);
                }else{
                    this.getData();
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isUpdatingList = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .list-brand__container {
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
    }
    .list-brand__item{
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
    .list-brand__item_pointer{
        cursor: pointer;
    }
    .list-brand__item_active{
        background: #dcdcdc;
    }
</style>